import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {alabaster, darkGray, denim, white} from '/theme/color/on.color';
import {onyx} from '/theme/color/on.color';
import {
  alto,
  codGray,
  gallery,
  graniteGray,
} from '/theme/color/secondary.color';
import {getFontFamily} from '/util/text.util';

export const styles = StyleSheet.create({
  base: {
    flex: 1,
  },
  taskItemContainer: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 8,
    borderStyle: 'solid',
    borderWidth: 1,
    marginBottom: indent * 0.5,
    paddingLeft: indent,
    paddingRight: indent * 0.5,
    paddingTop: indent,
    paddingBottom: indent,
  },
  enabledContainer: {
    backgroundColor: alabaster,
    borderColor: white,
  },
  disabledContainer: {
    backgroundColor: white,
    borderColor: alto,
  },
  taskItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
  },
  taskItemText: {
    fontSize: 14,
    marginLeft: indent * 0.5,
    flexShrink: 1,
    minWidth: 0,
  },
  itemSelectedText: {
    fontWeight: '600',
    color: darkGray,
  },
  itemDisabledText: {
    fontWeight: '600',
    color: graniteGray,
  },
  itemUnSelectedText: {
    ...getFontFamily('bold'),
    color: codGray,
  },
  iconContainer: {
    width: 24,
    height: 24,
    marginLeft: indent * 0.25,
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
  },
  selectedIcon: {
    fontSize: 22,
    color: denim,
  },
  unSelectedIcon: {
    fontSize: 22,
    borderColor: graniteGray,
    borderStyle: 'solid',
    borderWidth: 1,
    borderRadius: 2,
    color: white,
  },
  disabledIcon: {
    fontSize: 22,
    color: alabaster,
    borderStyle: 'solid',
    borderWidth: 0.5,
    borderRadius: 2,
    borderColor: gallery,
  },
  arrowIcon: {
    color: onyx,
    fontSize: 25,
    marginLeft: 'auto',
    flexShrink: 0,
  },
  optaviaText: {
    ...getFontFamily('regular'),
  },
});
